













































// doc: https://github.com/kaorun343/vue-property-decorator
import { Component, Prop, Watch } from 'vue-property-decorator'
import ViewBase from '@/utils/ViewBase'
import { setpassowrd } from '@/api/password'
// import { logout } from "../api/auth";


@Component
export default class TicketModal extends ViewBase {
  @Prop({ type: Boolean, default: false }) value!: boolean
  @Prop() id!: any

  loading: boolean = false
  form: any = null
  res: any = null
  manageuserId: any = null
  fileUrl: any = []
  files: any = ''
  headers: any = {
    authorization: 'authorization-text'
  }


  validater(rule: any, msg: any, callback: any) {
    if (msg && (msg + '').length > 0) {
       const {newPassword} = this.form.getFieldsValue(['newPassword'])
       if (newPassword == msg) {
           callback()
       } else {
           const info = '两次密码不一致'
          callback(new Error(`${info}`))
       }
    }
    callback()
  }

  created() {
    this.form = this.$form.createForm(this)
  }

  handleCancel() {
    this.form.resetFields()
    this.$emit('input', false)
  }

  async init() {
    this.value = true
  }

  async handleOk() {
    this.loading = true
    const flag = await this.form.validateFields()
    try {
      if (flag) {
        await setpassowrd({
            ...flag
        })
        this.$message.success(this.$t('base.success'))
        this.$emit('done')
        this.$emit('input', false)
        this.form.resetFields()
        this.loading = false
      }
    } catch (ex) {
      this.handleError(ex)
      this.loading = false
    }
  }

  @Watch('id', { immediate: true })
  watchId(val: any) {}
}
